export default __webpack_public_path__ + "static/bulkVp4-62115db1a0907d2f4333cd6cee6f3174.png";